<!--
 * @Author: your name
 * @Date: 2020-07-29 11:51:28
 * @LastEditTime: 2020-07-29 18:38:40
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/form/form-phone-input/form-phone-input.vue
-->
<template>
  <div class="form-phone-input form-item">
    <x-proxy-form-item
    :showRequired="showRequired"
    :label="widget.label"
    :processTitle="widget.processTitle"
    :validatorRules="validatorRules"
    :validateKey="validateKey"
    :validateInfo="validateInfo"
    :disabled="widget.readOnly">
      <x-input-phone
        v-if="renderSence === 'edit'"
        v-model="formValue"
        :disabled="widget.readOnly"
        :maxlength="widget.lengthLimit"
        :placeholder="widget.readOnly ? '' : widget.placeholder"
        :tabindex="tabindex"
      ></x-input-phone>
      <x-input-phone
        v-if="renderSence === 'read'"
        v-model="formValue"
        :maxlength="widget.lengthLimit"
        :renderSence="renderSence"
      ></x-input-phone>
    </x-proxy-form-item>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import XInputPhone from '../../x-input-phone/x-input-phone'
import WidgetPhoneValidator from '../../../form-validator/widget-phone-validator'

export default {
  name: 'FormPhoneInput',
  mixins: [FormWidgetConfigMixin],
  components: {
    XInputPhone
  },
  created() {
    this.widgetRules = [this._validate(WidgetPhoneValidator(`手机号码格式错误`))]
  }
}
</script>

<style lang="scss">
.form-phone-input {
  .x-input-phone {
    outline: none;
  }
}
</style>